export const STACKED_CHART = 'stacked';

export class ChartToggle {
  static parsePresentation(headings, dataPresentation) {
    // TODO cleanup
    return dataPresentation;
  }
}
